"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLoopToolbarButtons = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var TokenMenu_1 = require("../TokenMenu/TokenMenu");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var Types_2 = require("@CommonFrontend/Tokens/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var Types_3 = require("@CommonFrontend/ContentTokens/Models/inputs/Types");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var ContentLoopWidgetContext_1 = require("./ContentLoopWidgetContext");
var ContentLoopToolbarButtons = function (_a) {
    var element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var _b = (0, ContentLoopWidgetContext_1.useContentLoopWidgetContext)(), mode = _b.mode, setMode = _b.setMode;
    var removeToken = function () {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("contentLoop", {
            action: EditorTypes_1.ContentLoopActionType.RemoveContentLoopVariable,
            path: widgetManager.getPath(element),
        }));
    };
    var confirmToken = function (token) {
        if (!(0, Types_2.isListToken)(token)) {
            return;
        }
        var repeatingToken = new Types_3.RepeatingTokenInput(token.apiName, token.name, token.childObjectType, token.childPropertyLabel, SubstitutionTokenFactory_1.default.fromLegacyApiToken(token));
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("contentLoop", {
            action: EditorTypes_1.ContentLoopActionType.SetContentLoopVariable,
            path: widgetManager.getPath(element),
            variable: repeatingToken,
        }));
    };
    var closeTokenMenu = function () {
        setMode("none");
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        mode === "none" && (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tokens, null), onClick: function () {
                setMode("editToken");
            }, tooltip: { content: !!element.data.variable ? "Edit token" : "Add token" } })),
        mode === "editToken" && (react_1.default.createElement(TokenMenu_1.TokenMenu, { type: Types_1.TokenDataType.List, removeToken: removeToken, confirmToken: confirmToken, close: closeTokenMenu, matchEWRStyling: true, token: element.data.variable ? __assign(__assign({}, element.data.variable), { type: Types_1.TokenDataType.List }) : undefined }))));
};
exports.ContentLoopToolbarButtons = ContentLoopToolbarButtons;
